export default "__VITE_ASSET__00666192__"